import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Select from "react-select";

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import './Ship.css'
import { useTranslation } from "react-i18next";
import { fetchHoldCards, isPersonalInfoRestricted } from '../../../utils/apiClient';

const Hold = () => {
  const { t } = useTranslation();

  const [holdList, setHoldList] = useState([])
  const [isRestricted, setIsRestricted] = useState(false)
  const [restrictionMeta, setRestrictionMeta] = useState(null)

  useEffect(() => {

    const api = async () => {
      try {
        const response = await fetchHoldCards();
        const responseData = await response.json();
        
        // 新しいレスポンス形式に対応
        if (responseData.data) {
          setHoldList(responseData.data);
          setIsRestricted(responseData.meta?.personal_info_restricted || false);
          setRestrictionMeta(responseData.meta || null);
          
          if (responseData.meta?.personal_info_restricted) {
            console.log('個人情報が制限されています（保留中カード）:', responseData.meta?.message);
          }
        } else {
          setHoldList(responseData);
          setIsRestricted(false);
          setRestrictionMeta(null);
        }
      } catch (error) {
        console.error('保留中カードの取得に失敗しました:', error);
      }
    }

    const timer = setTimeout(() => {
      api();
    }, 500)
  
  }, [])



  
  const CreateShipmentList = () => {
    return holdList.map((ship) => {
      return (
        <>
          <tr>
            <td>{ship.name}</td>
            <td>{ship.rank}</td>
            <td>{ship.count}</td>
          </tr>
        </> 
      )
    })
  }


  return (
    <>
      <Header />
      <SideMenu />
      <div className="ship">
        <div className="ship-title">{t('hold.title')}</div>
        <div className='clearfix'></div>
        
        {/* WAF制限状態のバナー表示 */}
        {isRestricted && restrictionMeta && (
          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium">
                  {restrictionMeta.message}
                </p>
                <p className="text-xs text-yellow-600 mt-1">
                  理由: {restrictionMeta.restriction_reason}
                </p>
              </div>
            </div>
          </div>
        )}
        
        <div className="ship-content">
          <div className="ship-content-table">
            <table className="ship-content-table">
              <thead>
                <tr>
                  <th>{t('hold.name')}</th>
                  <th>{t('hold.rank')}</th>
                  <th>{t('hold.value')}</th>
                </tr>
              </thead>
              <tbody>
                <CreateShipmentList />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default Hold